import React, { useEffect, useState, useRef } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTooltip,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import {
  cardsActivationChannel,
  shareBalance,
  cardActivationMethod,
  cardActivationParameter,
  cardReloadingOptions,
} from "./stringUtils";
import TooltipIcon from "../../../Components/SharedComponent/TooltipIcon/TooltipIcon";
const CardActivationReloadingAndClosure = ({
  control,
  handleValueChanges,
  methods,
  errors,
}) => {
  const generalErrorMessage = "Please fill out this field.";
  const cardActivation = useRef(null);

  const handleCardActivationChannel = (event) => {
    let selectedChannels;
    if (!event.length) selectedChannels = event.target.value;
    else selectedChannels = event;
    let updatedCardsActivationChannel = methods.watch(
      "pf_card_activation_channels",
    );
    if (updatedCardsActivationChannel.includes(selectedChannels)) {
      // If the card is already selected, remove it
      updatedCardsActivationChannel = updatedCardsActivationChannel.filter(
        (card) => card !== selectedChannels,
      );
    } else {
      // If the card is not selected, add it
      updatedCardsActivationChannel.push(selectedChannels);
    }

    methods.setValue(
      "pf_card_activation_channels",
      updatedCardsActivationChannel,
    );
    methods.trigger();
    if (!updatedCardsActivationChannel.includes("other"))
      methods.clearErrors("pf_card_activation_channels_other");
    else if (!methods.getValues("pf_card_activation_channels_other").length)
      methods.setError("pf_card_activation_channels_other", {
        message: generalErrorMessage,
      });

    if (updatedCardsActivationChannel.length)
      methods.clearErrors("pf_card_activation_channels");
    else
      methods.setError("pf_card_activation_channels", {
        message: "At least one network must be selected",
      });
  };
  const handleCheckboxChange = ({
    value,
    fieldName,
    dependency, // optional
  }) => {
    let selected = methods.getValues(fieldName) ?? [];

    let updated = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];

    if (
      dependency?.field &&
      dependency?.resetValue !== undefined &&
      !updated.includes(dependency.resetValue)
    ) {
      methods.setValue(dependency.field, "");
    }

    methods.setValue(fieldName, updated);
    handleValueChanges();
    methods.trigger(fieldName);
  };

  return (
    <React.Fragment>
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">Activation Required?</div>
        </div>
        <div i2c-grid="12">
          <I2cRadioGroup
            onI2cChange={(e) => {
              methods.setValue("pf_card_activation_required", e.target.value);
              if (e.target.value === "yes") {
                methods.setValue("pf_card_activation_method", "");
              } else {
                methods.setValue("pf_card_activation_channels", []);
                methods.setValue("pf_card_activation_channels_other", "");
              }
              methods.trigger();
              handleValueChanges();
            }}
            value={methods.watch("pf_card_activation_required")}
          >
            {shareBalance.map((radio, index) => (
              <I2cRadioButton
                key={index}
                value={radio.toLocaleLowerCase()}
                label={radio}
              >
                {radio}
              </I2cRadioButton>
            ))}
          </I2cRadioGroup>
        </div>
      </div>
      {methods.watch("pf_card_activation_required") === "no" && (
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">Card Activation Method</div>
          </div>
          <div i2c-grid="12">
            <I2cRadioGroup
              name="cn_card_option"
              onI2cChange={(e) => {
                const value = e.target.value ?? "";
                methods.setValue("pf_card_activation_method", value);
                methods.trigger();
                handleValueChanges();
              }}
            >
              <div i2c-grid="grid gap-sm">
                {cardActivationMethod.map((option, index) => (
                  <I2cListItem
                    key={index}
                    i2c-grid="6@md"
                    variant="receipt"
                    label={option.label}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    sublabel=""
                    className="option-container"
                    checked={
                      methods.getValues("pf_card_activation_method") ===
                      option.value
                    }
                    type="checkbox"
                  >
                    <I2cRadio
                      slot="prefix"
                      filled
                      checked={
                        methods.getValues("pf_card_activation_method") ===
                        option.value
                      }
                      name="cardOption"
                      value={option.value}
                    ></I2cRadio>
                  </I2cListItem>
                ))}
              </div>
            </I2cRadioGroup>
          </div>
        </div>
      )}
      {methods.watch("pf_card_activation_required") === "yes" && (
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Card Activation Channels</div>
            <div className="custom-label-light">
              Select the i2c Inc. channels/interfaces you want the cardholders
              to use to activate card accounts.
            </div>
          </div>
          <div i2c-grid="12">
            <I2cCheckboxGroup ref={cardActivation}>
              <div i2c-grid="grid gap-sm">
                {cardsActivationChannel.map((card, index) => (
                  <div key={index} i2c-grid="6@md">
                    <I2cListItem
                      variant="receipt"
                      label={card.label}
                      sublabel=""
                      value=""
                      type="checkbox"
                      checked={
                        methods
                          .watch("pf_card_activation_channels")
                          ?.includes(card.value) ?? false
                      }
                      onI2cCheckboxClicked={(e) => {
                        handleCardActivationChannel(card.value);
                        handleValueChanges();
                      }}
                    >
                      <I2cCheckbox
                        slot="prefix"
                        value={card.value}
                        label=""
                        filled
                        ignoreTab
                        checked={
                          methods
                            .watch("pf_card_activation_channels")
                            ?.includes(card.value) ?? false
                        }
                        className="customCheckbox"
                      ></I2cCheckbox>
                    </I2cListItem>
                  </div>
                ))}
              </div>
            </I2cCheckboxGroup>
          </div>
          {methods.watch("pf_card_activation_channels").includes("other") && (
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_card_activation_channels_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      name={"pf_card_activation_channels_other"}
                      className="single-input-field"
                      placeholder="Please Specify"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                        if (value.length === 0) {
                          methods.setError(
                            "pf_card_activation_channels_other",
                            {
                              message: generalErrorMessage,
                            },
                          );
                        } else {
                        }
                      }}
                      required={
                        errors.pf_card_activation_channels_other ? true : false
                      }
                      size="large"
                      label="Please Specify"
                    />
                  )}
                />
              </div>
            </div>
          )}
        </div>
      )}
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12">
          <div className="organize-tooltip mb-16">
            <div className="sub-heading">
              Card Activation Parameters
            </div>
            <TooltipIcon
              content="i2c recommends using two factors  one from the card profile e.g. CVV and one from cardholder profile e.g. D.O.B."
            />
          </div>
          <div className="custom-label-light mb-16">
            Please confirm the parameters that will be used for card account
            activation.
          </div>
          <Controller
            name="pf_card_activation_parameters"
            control={control}
            render={({ field }) => (
              <I2cCheckboxGroup ref={cardActivation} {...field} label="">
                <div i2c-grid="grid gap-sm">
                  {cardActivationParameter.map((card, index) => (
                    <div key={index} i2c-grid="6@md">
                      <I2cListItem
                        variant="receipt"
                        label={card.label}
                        sublabel=""
                        value=""
                        type="checkbox"
                        checked={
                          methods
                            .watch("pf_card_activation_parameters")
                            ?.includes(card.value) ?? false
                        }
                        onI2cCheckboxClicked={(e) => {
                          handleCheckboxChange({
                            value: card.value,
                            fieldName: "pf_card_activation_parameters",
                          });
                        }}
                      >
                        <I2cCheckbox
                          slot="prefix"
                          value={card.value}
                          label=""
                          filled
                          ignoreTab
                          checked={
                            methods
                              .watch("pf_card_activation_parameters")
                              ?.includes(card.value) ?? false
                          }
                          className="customCheckbox"
                        ></I2cCheckbox>
                      </I2cListItem>
                    </div>
                  ))}
                </div>
              </I2cCheckboxGroup>
            )}
          />
        </div>
      </div>
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading mb-4">Card Reloading Options</div>
          <div className="custom-label-light mb-16">
            Select the load networks that will be enabled for card loads
          </div>
          <Controller
            name="pf_card_reloading_options"
            control={control}
            render={({ field }) => (
              <I2cCheckboxGroup ref={cardActivation} {...field} label="">
                <div i2c-grid="grid gap-sm">
                  {cardReloadingOptions.map((card, index) => (
                    <div key={index} i2c-grid="6@md 3@lg">
                      <I2cListItem
                        variant="receipt"
                        label={card.label}
                        sublabel=""
                        value=""
                        type="checkbox"
                        checked={
                          methods
                            .watch("pf_card_reloading_options")
                            ?.includes(card.value) ?? false
                        }
                        onI2cCheckboxClicked={(e) => {
                          handleCheckboxChange({
                            value: card.value,
                            fieldName: "pf_card_reloading_options",
                            dependency: {
                              field: "pf_card_reloading_options_other",
                              resetValue: "other",
                            },
                          });
                        }}
                      >
                        <I2cCheckbox
                          slot="prefix"
                          value={card.value}
                          label=""
                          filled
                          ignoreTab
                          checked={
                            methods
                              .watch("pf_card_reloading_options")
                              ?.includes(card.value) ?? false
                          }
                          className="customCheckbox"
                        ></I2cCheckbox>
                      </I2cListItem>
                    </div>
                  ))}
                </div>
              </I2cCheckboxGroup>
            )}
          />
        </div>
        {methods.watch("pf_card_reloading_options").includes("other") && (
          <div i2c-grid="3@md">
            <div className="single-field-wrapper">
              <Controller
                name="pf_card_reloading_options_other"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    name={"pf_card_reloading_options_other"}
                    className="single-input-field"
                    placeholder="Please Specify"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                      if (value.length === 0) {
                        methods.setError("pf_card_reloading_options_other", {
                          message: generalErrorMessage,
                        });
                      } else {
                      }
                    }}
                    size="large"
                    label="Please Specify"
                  />
                )}
              />
            </div>
          </div>
        )}
      </div>
      <div i2c-grid="grid gap-sm" className="section-space">
        <div i2c-grid="12@md">
          <div className="sub-heading">Card Closure</div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <div slot="label" className="organize-tooltip mb-6">
              <div className="custom-label">
                How will the card accounts be closed?
              </div>
            </div>
            <Controller
              name="pf_card_closure_how_will_card_be_closed"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Enter Here"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_card_closure_how_will_card_be_closed"}
                ></I2cInput>
              )}
            />
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <div slot="label" className="organize-tooltip mb-6">
              <div className="custom-label">
                How will the card account balance be treated at card closure?
              </div>
            </div>
            <Controller
              name="pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  placeholder="Enter Here"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={
                    "pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure"
                  }
                ></I2cInput>
              )}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardActivationReloadingAndClosure;
